import { render, staticRenderFns } from "./CommonNetDisk.vue?vue&type=template&id=2cfb053e&scoped=true"
import script from "./CommonNetDisk.vue?vue&type=script&lang=js"
export * from "./CommonNetDisk.vue?vue&type=script&lang=js"
import style0 from "./CommonNetDisk.vue?vue&type=style&index=0&id=2cfb053e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb053e",
  null
  
)

export default component.exports